import { render, staticRenderFns } from "./SiteVisitDashboardForEmployees.vue?vue&type=template&id=08c55cbf&"
import script from "./SiteVisitDashboardForEmployees.vue?vue&type=script&lang=js&"
export * from "./SiteVisitDashboardForEmployees.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports